<template>
  <div id="app"
       :class="$route.meta.routerClass">
    <VipHeader v-if="$route.name && $route.name !== 'mark'&& !$route.name.startsWith('compose_')" />

    <router-view />
    <VipFooter v-if="
        $route.name &&
        !$route.name.startsWith('console_') &&
        $route.name !== 'mark' &&
        !$route.name.startsWith('compose_')
      " />
    <div class="float-tool"
         v-if="$route.name && !$route.name.startsWith('compose_')">
      <div class="tool-group">
        <el-button @click="handleMenuVisible"
                   class="tool-text"
                   type=""
                   v-if="
            $route.name === 'company_detail' ||
            $route.name === 'industry_detail' ||
            $route.name === 'school_detail' ||
            $route.name === 'region_detail'
          ">
          目录
        </el-button>
        <el-button @click="
            () => {
              this.getPdf('pdfDomTitle', 'pdfDom');
            }
          "
                   class="tool-text"
                   type=""
                   v-if="
            $route.name === 'company_detail' ||
            $route.name === 'industry_detail' ||
            $route.name === 'school_detail' ||
            $route.name === 'region_detail'
          ">
          导出<br />PDF
        </el-button>
        <!-- <el-button type="" icon="el-icon-c-scale-to-original">
          对比分析
        </el-button>
        <el-button type="" icon="el-icon-document"> 定制报告 </el-button> -->
        <el-button @click="showFeedback"
                   type=""
                   icon="el-icon-chat-line-square">
          用户反馈
        </el-button>
      </div>
      <el-button type=""
                 icon="el-icon-caret-top"
                 @click="backToTop">
        返回顶部
      </el-button>
    </div>
    <el-dialog class="feedback"
               :visible.sync="feedbackVisible"
               title="用户反馈">
      <el-form label-width="80px"
               size="small"
               :rules="feedbackRules"
               :model="feedbackModel"
               ref="feedbackForm">
        <el-form-item label="标题"
                      required
                      prop="title">
          <el-input placeholder=""
                    v-model="feedbackModel.title"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      required
                      prop="email">
          <el-input placeholder=""
                    v-model="feedbackModel.email"></el-input>
        </el-form-item>
        <el-form-item label="反馈意见"
                      required
                      prop="content">
          <el-input type="textarea"
                    v-model="feedbackModel.content"
                    :rows="5"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="code"
                      label="验证码"
                      required
                      prop="code">
          <el-input placeholder=""
                    v-model="feedbackModel.code"
                    v-loading="codeLoading"
                    style="width: 250px">
            <img :src="this.codeUrl"
                 slot="append"
                 alt=""
                 @click="getImgCode()" />
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="submitFeedback">确 定</el-button>
        <el-button @click="feedbackVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VipHeader from "@/components/header";

import VipFooter from "@/components/footer";
import { axiosOptions, axiosRequest } from "./util/request";

export default {
  components: { VipHeader, VipFooter },
  name: "App",
  data () {
    return {
      menuVisible: false,
      menuStyle: "",
      feedbackVisible: false,
      codeUrl: "",
      codeLoading: false,
      accessToken: "",
      feedbackModel: {
        title: "",
        email: "",
        content: "",
        code: "",
      },
      feedbackRules: {
        title: [{ required: true, message: "验标题不能为空", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          { required: true, message: "反馈意见不能为空", trigger: "blur" },
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
    };
  },
  mounted () {
  },
  methods: {
    submitFeedback () {
      this.$refs.feedbackForm.validate((validate) => {
        if (validate) {
          axiosRequest(
            "/feedback/add",
            {
              title: this.feedbackModel.title,
              email: this.feedbackModel.email,
              content: this.feedbackModel.content,
              accessToken: this.accessToken,
              code: this.feedbackModel.code,
            },
            axiosOptions("post", "", "json")
          )
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("提交成功");
                this.feedbackVisible = false;
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(() => {
              this.$message.error("提交失败，请稍后重试");
            });
        }
      });
    },
    showFeedback () {
      this.getImgCode();
      this.feedbackVisible = true;
    },
    getImgCode () {
      this.codeLoading = true;
      axiosRequest("/tool/verify-code", {}, axiosOptions("get", "", "blob"))
        .then((res) => {
          this.codeLoading = false;
          if (res.data && res.status == 200) {
            let blob = new Blob([res.data]); // 返回的文件流数据
            this.codeUrl = window.URL.createObjectURL(blob);
            this.accessToken = res.headers["verify-code-access-token"];
          } else {
            this.$message.error("获取验证码失败");
          }
        })
        .catch(() => {
          this.codeLoading = false;
          this.$message.error("获取验证码失败");
        });
    },
    backToTop () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleMenuVisible () {
      document.getElementById("catalog").className = "catalog is-active";
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input-group__append {
  padding: 0 0 0 18px;
  border: 0;
  background-color: transparent;
  img {
    height: 30px;
    margin: 0;
    vertical-align: top;
  }
}
</style>